import React from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const SponsorsList = ({ sponsors, arenaId }) => {
  if (!sponsors || sponsors.length === 0) {
    return null;
  }

  const trackSponsorClick = (sponsorData) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'sponsor_click',
        sponsor_id: sponsorData.id,
        sponsor_name: sponsorData.sponsorName,
        sponsor_url: sponsorData.sponsorURL,
        arena_id: arenaId,
        click_time: new Date().toISOString()
      });
    }
  };

  return (
    <div className="sponsors-section">
      <Row>
        <Col className="col-12">
          <div className="places-title pb-4 pt-4 fw-bold">
            Apoio
          </div>
        </Col>
      </Row>
      <Row className="justify-content-left">
        {sponsors.map((sponsor, index) => (
          <Col
            key={index}
            className="col-6 col-md-4 col-lg-3 pb-4 mb-2"
          >
            <a
              href={`${sponsor.sponsorURL}`}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackSponsorClick(sponsor)}
              className="sponsor-card d-flex align-items-center justify-content-center h-100 p-3"
            >
              <img
                src={`/logos/${arenaId}/sponsors/${sponsor.id}.svg`}
                alt={`${sponsor.sponsorName}`}
                className="img-fluid sponsor-img"
              />
            </a>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default SponsorsList;